import en from './en';
import hu from './hu';
import de from './de';

const languagePack = {
  en,
  hu,
  de
};

export default languagePack;
